<template>
  <div :class="{ contenedor_home: esActiva }">
    <Splash :isLoading="isLoading" :mostrarCargando="mostrarCargando" />
    <main v-if="!isLoading">
      <Bienvenida v-if="!esActiva && !esSPD" />

      <BienvenidaConfianza
        v-if="esActiva"
        @comenzar="aComenzar"
        v-bind:folioDigital="this.folioDigital"
      />

      <BienvenidaConfianzaSPD v-if="esSPD" @comenzar="aComenzar" />
      <!-- <Bienvenida /> -->
    </main>
  </div>
</template>

<script>
import Bienvenida from '@/views/inicio/Bienvenida.vue'
import BienvenidaConfianza from '@/views/inicio/BienvenidaConfianza.vue'
import BienvenidaConfianzaSPD from '@/views/inicio/BienvenidaConfianzaSPD.vue'
import Splash from '@/views/principal/Splash.vue'
import { ObtieneTokenAutenticacionMixin } from '@/mixins/autenticacion/ObtieneTokenAutenticacion.mixin'
import { ObtieneOfertaDigitalMixin } from '@/mixins/credito/ObtieneOfertaDigital.mixin'
import { ObtienePersonaMixin } from '@/mixins/persona/ObtienePersona.mixin'
import { ObtieneFrecuenciaPlazoProductoMixin } from '@/mixins/credito/ObtieneFrecuenciaPlazoProducto.mixin'
import { ObtieneCreditoPagoSimuladoMixin } from '@/mixins/credito/ObtieneCreditoPagoSimulado.mixin'
import personaService from '@/servicios/persona'
import { InsertaLogMixin } from '@/mixins/credito/InsertaLog.mixin'
import {
  ALERTA_ERROR,
  // ID_PRODUCTO_DOCUMENTO_COMPROBANTE_DOMICILIO,
  // ID_PRODUCTO_CREDITO_ENLAZAMAS,
  ID_PRODUCTO_CREDITO_ACTIVACASH,
  ID_PRODUCTO_CREDITO_SP,
  ID_PRODUCTO_CREDITO_SPLUS,
} from '@/utilidades/utilidades'
import * as Sentry from '@sentry/browser'

export default {
  name: 'Principal',
  components: {
    Bienvenida,
    Splash,
    BienvenidaConfianza,
    BienvenidaConfianzaSPD,
  },
  mixins: [
    ObtieneTokenAutenticacionMixin,
    ObtieneOfertaDigitalMixin,
    ObtienePersonaMixin,
    ObtieneFrecuenciaPlazoProductoMixin,
    ObtieneCreditoPagoSimuladoMixin,
    InsertaLogMixin,
  ],
  data() {
    return {
      permitirContinuar: false,
      isLoading: true,
      folioDigital: null,
      idSubproducto: null,
      mostrarCargando: true,
      devuelveMonto: false,
      esActiva: false,
      aplicaVerSeguimiento: false,
      esSPD: false,
    }
  },
  methods: {
    aComenzar() {
      this.esActiva = true
      this.esSPD = false
    },
    casoAplicaVerSeguimiento(estatus, subestatus) {
      return (
        (estatus == 2 && !(subestatus == 1 || subestatus == 5)) || estatus >= 3
      )
    },
    enviarAlertaError(mensaje, tiempo, visibilidad) {
      this.mostrarCargando = false
      this.$store.dispatch('alerta/enviarAlertaError', {
        mensaje,
        tiempo,
        visibilidad,
      })
    },
    establecerProcesoActivo(tipoPersona) {
      let procesoActivo = 'activaCash'
      if (tipoPersona === 1) {
        procesoActivo = 'activaCash'
      } else {
        procesoActivo = 'enlazaMas'
      }
      this.$store.commit('guia/establecerProcesoActivo', { procesoActivo })
    },
    cargarInformacion() {
      this.obtieneTokenAutenticacion()
    },
    postObtieneTokenAutenticacion(result) {
      this.$store.dispatch('sesion/actualizarToken', { token: result.Token })
      this.obtieneOfertaDigital(this.folioDigital)
    },
    postObtieneOfertaDigital(result) {
      const aplicaDevolucion = result.DatosGenerales[0].aplicaDevolucion
      this.idSubproducto = result.DatosGenerales[0].Id_subproducto
      this.esActiva =
        this.idSubproducto == ID_PRODUCTO_CREDITO_ACTIVACASH ? true : false
      this.esSPD =
        this.idSubproducto == ID_PRODUCTO_CREDITO_SP ||
        this.idSubproducto == ID_PRODUCTO_CREDITO_SPLUS
          ? true
          : false
      this.devuelveMonto = result.DatosGenerales[0].id_sub_status == 5
      this.aplicaVerSeguimiento = this.casoAplicaVerSeguimiento(
        result.DatosGenerales[0].id_status,
        result.DatosGenerales[0].id_sub_status
      )
      this.establecerProcesoActivo(result.DatosGenerales[0].Id_tipo_persona)
      this.$store.dispatch('credito/actualizarFolioDigital', {
        folioDigital: this.folioDigital,
      })
      Sentry.setContext('character', result.DatosGenerales[0])
      if (this.devuelveMonto || aplicaDevolucion) {
        this.$store.dispatch(
          'credito/setIdSolicitud',
          result.DatosGenerales[0].id_solicitud
        )
        this.$store.dispatch(
          'credito/setAplicaDevolucion',
          result.DatosGenerales[0].aplicaDevolucion
        )
        this.$store.dispatch(
          'credito/setAplicaDevolucionMonto',
          result.DatosGenerales[0].id_sub_status == 5
        )
        this.$store.dispatch(
          'personaDocumentos/establecerDocumentos',
          result.DocumentacionFaltante
        )
        this.$store.dispatch(
          'credito/setObservacionesDevolucion',
          result.DatosGenerales[0].observacionesDevolucion
        )
      }
      if (result.DocumentacionFaltante.find((doc) => doc.id_documento == 4)) {
        this.$store.dispatch('credito/setAplicaDevolucionDomicilio', true)
      }
      if (aplicaDevolucion && !this.devuelveMonto) {
        if (this.$store.getters['credito/obtenerAplicaDevolucionDomicilio']) {
          // this.$store.dispatch('credito/setAplicaDevolucionDomicilio', true)
          this.$router.push('/datosDomicilio')
        } else {
          // this.$store.dispatch(
          //   'credito/setIdSolicitud',
          //   result.DatosGenerales[0].id_solicitud
          // )
          // this.$store.dispatch(
          //   'credito/setAplicaDevolucion',
          //   result.DatosGenerales[0].aplicaDevolucion
          // )
          // this.$store.dispatch(
          //   'personaDocumentos/establecerDocumentos',
          //   result.DocumentacionFaltante
          // )
          // this.$store.dispatch(
          //   'credito/setObservacionesDevolucion',
          //   result.DatosGenerales[0].observacionesDevolucion
          // )
          // if (this.devuelveMonto) {
          //   const obtenerPersonaRequest =
          //     this.$store.getters['persona/obtenerPersonaRequest']
          //   this.obtienePersona(obtenerPersonaRequest)
          //   // this.$router.push('/actualizaMonto')
          // } else {
          this.$router.push('/actualizaDocumentos')
        }
        // }
      } else {
        this.$store.dispatch(
          'persona/establecerCelularOferta',
          result.DatosGenerales[0].Celular
        )
        this.$store.dispatch(
          'persona/actualizarDatosPersonales',
          result.DatosGenerales[0]
        )
        this.$store.dispatch(
          'credito/actualizarEntrada',
          result.DatosGenerales[0]
        )
        // this.$store.dispatch('credito/actualizarFolioDigital', {
        //   folioDigital: this.folioDigital,
        // })
        this.$store.dispatch(
          'credito/actualizaFechaVigencia',
          result.DatosGenerales[0].fechaVigencia
        )
        if (this.aplicaVerSeguimiento) {
          this.$router.push('/avanceCredito')
          return
        } else {
          const obtenerPersonaRequest =
            this.$store.getters['persona/obtenerPersonaRequest']
          this.obtienePersona(obtenerPersonaRequest)
        }
      }
    },
    postObtienePersona(persona) {
      this.$store.dispatch('persona/actualizarDatosPersonales', persona)
      this.$store.dispatch('persona/establecerDireccion', persona)
      this.obtieneFrecuenciaPlazoProducto(this.idSubproducto, this.folioDigital)
      if (persona.Id_Prospecto) {
        personaService
          .verificarSocio(persona)
          .then((result) => {
            if (result.status != 200) {
              this.errorObtienePersona(result.data.Mensaje)
              return
            }
            const data = result.data
            if (data.Codigo != 200) {
              this.errorObtienePersona(data.Mensaje)
              return
            }
            // this.postObtienePersona(data.Modelo)
            this.$store.dispatch(
              'persona/establecerDatosVerificados',
              data.Modelo
            )
          })
          .catch((err) => {
            console.error(err)
            this.errorObtienePersona(err)
          })
      }
      if (this.devuelveMonto) {
        // this.obtienePersona(obtenerPersonaRequest)
        this.$store.dispatch('credito/actualizarEditable', false)
        this.$router.push('/actualizaMonto')
      }
    },
    postObtieneFrecuenciaPlazoProducto(result) {
      this.InsertaLog()
      // console.log(result)
      // console.log('aqui viene lo que buscas', result)
      this.$store.dispatch('credito/establecerPlazosInicio', result)
      this.$store.dispatch('credito/establecerRangoMontosPlazos', result)
      this.$store.dispatch('credito/actualizarPlazos')
      this.$store.dispatch(
        'credito/actualizaCatalagoPeriodicidad',
        result.Periodicidad
      )
      // const tipoCredito =
      //   this.$store.getters['credito/obtenerCredito'].tipoCredito
      // const tipoPersona =
      //   this.$store.getters['persona/obtenerPersona'].tipoPersona
      let documentos = result.Documentos
      let documentosRequeridos = result.Documentos_Requeridos
      // se comenta esta seccion porque ahora a todos se les solicita su comprobante de domicilio
      // if (tipoCredito == ID_PRODUCTO_CREDITO_ENLAZAMAS && tipoPersona == 1) {
      //   // Se elimina el comprobante de domicilio de los documentos necesarios
      //   documentos = documentos.filter(
      //     (documento) =>
      //       documento.id_documento !=
      //       ID_PRODUCTO_DOCUMENTO_COMPROBANTE_DOMICILIO
      //   )
      //   let documentosRequeridosArray = documentosRequeridos.split(',')
      //   documentosRequeridosArray.splice(1, 1)
      //   documentosRequeridos = documentosRequeridosArray.join(',')
      // }
      if (!this.devuelveMonto) {
        this.$store.dispatch(
          'personaDocumentos/establecerDocumentos',
          documentos
        )
        this.$store.dispatch(
          'personaDocumentos/insertarDocumentosASolicitar',
          documentosRequeridos
        )
      }
      // console.log(this.$store.getters['credito/obtenerCredito'])
      this.obtieneCreditoPagoSimulado(
        this.$store.getters['credito/obtenerCredito']
      )
    },
    postObtieneCreditoPagoSimulado(result) {
      this.$store.dispatch('credito/actuliazarMontoPago', result)
      this.isLoading = false
    },
    errorObtieneTokenAutenticacion(mensaje) {
      this.enviarAlertaError(mensaje, ALERTA_ERROR.tiempo, ALERTA_ERROR.visible)
      this.reenviarAPaginaCmv(ALERTA_ERROR.tiempo)
    },
    errorObtieneOfertaDigital(mensaje) {
      mensaje += '. Serás redireccionado a la página de Caja Morelia Valladolid'
      this.enviarAlertaError(mensaje, ALERTA_ERROR.tiempo, ALERTA_ERROR.visible)
      this.reenviarAPaginaCmv(ALERTA_ERROR.tiempo)
      // this.insertaLog({
      //   folioDigital: this.folioDigital,
      //   exception_error: mensaje,
      // })
    },
    errorObtienePersona(mensaje) {
      this.enviarAlertaError(mensaje, ALERTA_ERROR.tiempo, ALERTA_ERROR.visible)
      this.reenviarAPaginaCmv(ALERTA_ERROR.tiempo)
    },
    errorObtieneFrecuenciaPlazoProducto(mensaje) {
      this.enviarAlertaError(mensaje, ALERTA_ERROR.tiempo, ALERTA_ERROR.visible)
      this.reenviarAPaginaCmv(ALERTA_ERROR.tiempo)
    },
    errorObtieneCreditoPagoSimulado(mensaje) {
      this.enviarAlertaError(mensaje, ALERTA_ERROR.tiempo, ALERTA_ERROR.visible)
      this.reenviarAPaginaCmv(ALERTA_ERROR.tiempo)
    },
    reenviarAPaginaCmv(tiempo) {
      console.log(tiempo)
      // setTimeout(() => {
      //   window.location.href = 'https://www.cajamorelia.com.mx/'
      // }, tiempo)
    },
  },
  async created() {
    this.folioDigital = this.$route.query.folio
    const medio_de_contacto = this.$route.query.m
    if (!this.folioDigital) {
      this.enviarAlertaError(
        ALERTA_ERROR.mensaje +
          '. Serás redireccionado a la página de Caja Morelia Valladolid',
        ALERTA_ERROR.tiempo,
        ALERTA_ERROR.visible
      )
      this.reenviarAPaginaCmv(ALERTA_ERROR.tiempo)
    } else {
      this.cargarInformacion()
      if (medio_de_contacto) {
        this.$gtag.event('medioContacto', {
          event_category: 'Enter Page',
          event_label: 'Medio de contacto',
          value: medio_de_contacto,
        })
        this.$store.dispatch(
          'credito/actualizarMedioContacto',
          medio_de_contacto
        )
      }
      this.$gtag.event('cargarFolio', {
        event_category: 'Enter Page',
        event_label: 'Folio Digital',
        value: this.folioDigital,
      })
      this.$gtag.config({ user_id: this.folioDigital })
      this.$gtag.config({ folio_id: this.folioDigital })
      // this.$gtag('cargarFolio', {
      //   event_category: 'Enter Page',
      //   event_label: 'Folio Digital',
      //   value: this.folioDigital,
      // })
      // this.$gtag('config', 'MEASUREMENT_ID', { user_id: this.folioDigital })
    }

    // const successPos = (position) => {
    //   const latitude = position.coords.latitude
    //   const longitude = position.coords.longitude
    //   // Do something with the position
    //   // console.log(latitude, longitude)
    //   this.$store.dispatch('credito/actualizarUbicacion', {
    //     lon: longitude,
    //     lat: latitude,
    //   })
    // }

    // const errorPos = () => {
    //   console.error('No se pudo obtener la ubiación')
    // }
    // This will open permission popup
    // navigator.geolocation.getCurrentPosition(successPos, errorPos)
  },
}
</script>

<style scoped>
.contenedor_home {
  background: linear-gradient(180deg, #27aa46 1%, #093a01 100%);
}
</style>
